import Vue from 'vue'
import Vuex from 'vuex'
import activity from './modules/activity'
import course from './modules/course'
import title from './modules/title'
import norms from './modules/norms'
import pathify from 'vuex-pathify'
Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [
        pathify.plugin
    ],

    modules: {
        activity,
        course,
        title,
        norms,
    }
})
